import {
  API_CALL_SUCCESS,
  CLEAR_AUTH_ERROR, RESET_CUSTOMER_TRAVELLER_SUBMISSION, SET_CUSTOMER_VALUE,
  SET_RECENTLY_USED_AIRPORT_CODE,
  SYNC_USER_DETAILS,
  ADD_USER_CART_CONNECTED_ROOMS,
  ADD_USER_CART_ITEMS,
  CLEAR_PURCHASED_USER_CART_ITEMS,
  SYNC_USER_CART,
  SAVE_USER_CART_ITEM_FOR_LATER,
  SAVE_ALL_USER_CART_ITEMS_FOR_LATER,
  UPDATE_USER_CART_ITEM,
  UNDO_USER_CART_ITEMS_DELETE,
  RESET_USER_CART,
  REMOVE_USER_CART_CONNECTED_ROOM,
  SAVE_USER_CART_ITEMS_FOR_LATER,
  DELETE_USER_CART_ITEMS,
  HARD_DELETE_USER_CART_ITEMS,
  API_CALL_FAILURE,
} from 'actions/actionConstants'
import { GSI_SCRIPT_LOADED, API_CALL, SAVE_CUSTOMER_SIGNATURE, DELETE_CUSTOMER_SIGNATURE } from './actionConstants'
import {
  FETCH_AVAILABLE_CREDIT,
  FETCH_PAYMENT_CARDS,
  USER_LOGIN,
  USER_REGISTRATION,
  UPDATE_USER_DETAILS,
  USER_LOGOUT,
  UPDATE_ACCOUNT_PARTNERSHIP,
  USER_FORGOT_PASSWORD,
  LINK_PARTNERSHIP_ACCOUNT,
  FETCH_STRIPE_PAYMENT_CARDS,
  CHECK_LEGACY_ORDERS_FOR_CURRENT_USER,
  CHECK_USER_EXISTS,
  USER_RESET_PASSWORD,
  FETCH_CUSTOMER_DETAILS,
  DELETE_CUSTOMER_DETAILS,
  UPDATE_CUSTOMER_DETAILS, SEND_VERIFICATION_CODE,
  UPDATE_ADD_PHONE_PROMPTED,
  FETCH_CUSTOMER_TRAVELLERS,
  DELETE_CUSTOMER_TRAVELLER,
  SUBMIT_CUSTOMER_TRAVELLER,
  FETCH_USER_CART,
  USER_EMAIL_CONFIRMATION,
} from './apiActionConstants'
import { getAvailableCredit, getSavedCardsFromStripe, getLedLegacyOrders, getSavedCardsOnStripe } from 'api/order'
import { getSavedStripeCards } from 'api/payment'
import * as authService from 'api/auth'
import { sendResetPasswordEmail, updatePartnershipDetails, resetPassword, requestUserEmailValidation } from 'api/auth'
import { setTimeUserLastSeenSnackbar } from 'storage/creditsSnackbar'
import { getCreditSnackbar, shouldShowCreditSnackbar } from 'lib/customer/creditSnackbarUtils'
import { replaceWithRegion } from './NavigationActions'
import { deleteCustomerDetails, getCustomerDetails, getCustomerTravellers, updateCustomerDetails, deleteCustomerTraveller, updateCustomerTraveller, createCustomerTraveller } from 'api/traveller'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import ReCAPTCHA from 'react-google-recaptcha'
import { isStripePaymentElementCardAvailable, isStripe3dsV2Available } from 'checkout/selectors/payment/paymentType'
import { replace } from 'connected-react-router'
import { isLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { AppAction } from './ActionTypes'
import { getUserCart } from 'api/cart'
import { selectLoggedIn } from 'selectors/accountSelectors'
import showAddToUserCartSnackbar from 'components/utils/showAddToUserCartSnackbar'
import { getAddToCartSnackbarData, getUserCartAbandonableItems, getUserCartItemsArray } from 'selectors/userCart'
import { ValueOf } from 'type-fest'
import { prepareItem } from 'lib/checkout/userCart'
import { isFlightItem } from 'lib/checkout/checkoutUtils'
import config from 'constants/config'

const HIGH_VALUE_OFFER_AMOUNT = 4999
const MID_VALUE_OFFER_AMOUNT = 2999

// TODO: Fill this out with the other auth actions
type Actions = Utils.FullActionMap<{
  [ADD_USER_CART_ITEMS]: { items: Array<App.Checkout.AnyItem> },
  [UPDATE_USER_CART_ITEM]: { item: App.Checkout.AnyItem },
  [DELETE_USER_CART_ITEMS]: { itemIds: Array<string> },
  [HARD_DELETE_USER_CART_ITEMS]: { itemIds: Array<string> },
  [UNDO_USER_CART_ITEMS_DELETE]: { itemIds: Array<string> },
  [SAVE_USER_CART_ITEMS_FOR_LATER]: { itemIds: Array<string> },
  [RESET_USER_CART]: {},
  [SAVE_USER_CART_ITEM_FOR_LATER]: { itemId: string },
  [SAVE_ALL_USER_CART_ITEMS_FOR_LATER]: {},
  [SYNC_USER_CART]: { userCartState: App.UserCartState },
  [ADD_USER_CART_CONNECTED_ROOMS]: { connectedRoomOfferIds: Array<string> },
  [REMOVE_USER_CART_CONNECTED_ROOM]: { connectedRoomOfferId: string },
  [CLEAR_PURCHASED_USER_CART_ITEMS]: { purchasedItemIds: Set<string> },
}>

export type AuthAction = ValueOf<Actions>

export function getUserKeyFromPhone(phoneNumber: App.PhoneNumber): string {
  return `+${phoneNumber.prefix}${phoneNumber.phone}`
}

export function checkUserExists(
  user: { email?: string, phoneNumber?: App.PhoneNumber},
  recaptchaApi?: ReCAPTCHA | null,
): AppAction {
  return (dispatch, getState) => {
    const key = user.email ?? (user.phoneNumber ? getUserKeyFromPhone(user.phoneNumber) : undefined)
    if (!key) {
      return
    }
    const state = getState()
    // no need to check again, we've already done so
    if (state.auth.users[key]) {
      return
    }

    dispatch({
      type: API_CALL,
      api: CHECK_USER_EXISTS,
      request: async() => {
        let recaptchaData: string | null | undefined
        if (recaptchaApi) {
          recaptchaData = await recaptchaApi.executeAsync()
        }
        return authService.checkUserExists(user, recaptchaData)
      },
      email: user.email,
      phoneNumber: user.phoneNumber,
      key,
    })
  }
}

export function loginNativeApp(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.webViewAccountAccess(state.geo.currentRegionCode, isLuxPlusEnabled(state)),
    })
  } }

export function login(
  user: App.User,
  password: string,
  recaptchaData: string,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)
    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.login(user, password, recaptchaData, state.geo.currentRegionCode, luxPlusEnabled),
      source: user.email ? 'email' : 'phone',
    })
  }
}

export interface GoogleLoginData {
  id_google: string;
  email: string;
  token_id: string,
  givenName: string;
  surname: string;
}

export function loginGoogle(data: GoogleLoginData): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)
    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.loginGoogle(data, state.geo.currentRegionCode, luxPlusEnabled),
      source: 'google',
    })
  }
}

export interface FacebookLoginData {
  app_id: string;
  email: string;
  access_token: string;
  givenName: string;
  surname: string;
}

export function loginFacebook(data: FacebookLoginData): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)

    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.loginFacebook(data, state.geo.currentRegionCode, luxPlusEnabled),
      source: 'facebook',
    })
  }
}

export interface AppleLoginData {
  id_token: string;
  givenName?: string;
  firstName?: string;
}

export function loginApple(data: AppleLoginData): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)

    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.loginApple(data, state.geo.currentRegionCode, luxPlusEnabled),
      source: 'apple',
    })
  }
}

const registerMethods = {
  phone: authService.register,
  email: authService.register,
  google: authService.loginGoogle,
  facebook: authService.loginFacebook,
  apple: authService.loginApple,
}

export function register(userData: Partial<App.AuthAccount> & { password: string }, source: App.SignUpAuthSource): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const registerData = {
      ...userData,
      utmAdgroup: state.utm.adgroup,
      utmCampaign: state.utm.campaign,
      utmContent: state.utm.content,
      utmMedium: state.utm.medium,
      utmSource: state.utm.source,
      utmTerm: state.utm.term,
    }

    dispatch({
      type: API_CALL,
      api: USER_REGISTRATION,
      source,
      request: () => registerMethods[source]((registerData as any), state.geo.currentRegionCode),
    })
  }
}

const verifyUserErrorMessage = "We couldn't verify your email, please try again."
export function verifyUserEmail(token: string, showErrorSnackbar = true): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: USER_EMAIL_CONFIRMATION,
      request: async() => {
        try {
          await requestUserEmailValidation({ token, brand: config.BRAND })
          showSnackbar('Your email has been successfully verified.', 'success')
          dispatch(replaceWithRegion('/'))
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error: any) {
          if (showErrorSnackbar) showSnackbar(verifyUserErrorMessage, 'critical')
          dispatch({
            type: API_CALL_FAILURE,
            api: USER_EMAIL_CONFIRMATION,
            error: { message: verifyUserErrorMessage },
          })
        }
      },
    })
  }
}

export function resetUserPassword(token: string, password: string, callbackPath?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)
    dispatch({
      type: API_CALL,
      api: USER_RESET_PASSWORD,
      request: () => resetPassword({ token, password, luxPlusEnabled }).then(data => {
        showSnackbar('Your password has been successfully reset', 'success')
        dispatch(callbackPath ? replace(callbackPath) : replaceWithRegion('/'))

        dispatch({
          type: API_CALL_SUCCESS,
          api: USER_LOGIN,
          data,
        })

        return data
      }),
    })
  }
}

export function forgotPassword(email: string, callbackPath?: string): AppAction {
  return {
    type: API_CALL,
    api: USER_FORGOT_PASSWORD,
    request: () => sendResetPasswordEmail(email, callbackPath),
  }
}

export function linkPartnershipAccount(partnershipPrefix: string, details: any): AppAction {
  return {
    type: API_CALL,
    api: LINK_PARTNERSHIP_ACCOUNT,
    request: () => updatePartnershipDetails({ [partnershipPrefix]: details }),
    prefix: partnershipPrefix,
    details,
  }
}

export function authLogout(): AppAction {
  return {
    type: API_CALL,
    api: USER_LOGOUT,
    request: () => authService.logout(),
  }
}

export function fetchAvailableCreditAndOpenSnackbar(currencyCode?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const memberId = state.auth.account.memberId
    if (!memberId) { return }

    dispatch({
      type: API_CALL,
      api: FETCH_AVAILABLE_CREDIT,
      request: () => getAvailableCredit(
        memberId,
        currencyCode ?? state.geo.currentCurrency,
      ).then(resp => {
        if (!resp.balance) return resp
        const {
          geo: { currentCurrency, currentRegionCode },
          router: { location: { pathname } },
          system: { headlessMode },
        } = state

        if (shouldShowCreditSnackbar(resp.balance, currentCurrency, pathname, memberId, headlessMode)) {
          const creditSnackbar = getCreditSnackbar(resp.balance, currentCurrency, currentRegionCode)
          showSnackbar(creditSnackbar.message, 'success', { heading: creditSnackbar.heading })
          setTimeUserLastSeenSnackbar(memberId)
        }
        return resp
      }),
      currencyCode: currencyCode ?? state.geo.currentCurrency,
    })
  }
}

export function fetchAvailableCredit(currencyCode?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const memberId = state.auth.account.memberId
    if (!memberId) { return }

    dispatch({
      type: API_CALL,
      api: FETCH_AVAILABLE_CREDIT,
      request: () => getAvailableCredit(
        memberId,
        currencyCode ?? state.geo.currentCurrency,
      ),
      currencyCode: currencyCode ?? state.geo.currentCurrency,
    })
  }
}

export function openCreditSnackbar(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const {
      geo: { currentCurrency, currentRegionCode },
      router: { location: { pathname } },
      auth: { account: { balance, memberId } },
      system: { headlessMode },
    } = state

    if (memberId && shouldShowCreditSnackbar(balance, currentCurrency, pathname, memberId, headlessMode)) {
      const creditSnackbar = getCreditSnackbar(balance, currentCurrency, currentRegionCode)
      showSnackbar(creditSnackbar.message, 'success', { heading: creditSnackbar.heading })
      setTimeUserLastSeenSnackbar(memberId)
    }
  }
}

export function setRecentlyUsedAirportCode(airportCode: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.auth.account.memberId) {
      dispatch({
        type: API_CALL,
        api: SET_RECENTLY_USED_AIRPORT_CODE,
        request: () => authService.updateUserDetails({ recentlyUsedAirportCode: airportCode }),
        airportCode,
      })
    }
  }
}

export function updateAddPhonePromptedAt(addPhonePromptedAt: Date): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.auth.account.memberId) {
      dispatch({
        type: API_CALL,
        api: UPDATE_ADD_PHONE_PROMPTED,
        request: () => authService.updateAddPhonePromptedAt(addPhonePromptedAt),
        addPhonePromptedAt: addPhonePromptedAt.toISOString(),
      })
    }
  }
}

export function fetchPaymentCards(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!isStripePaymentElementCardAvailable(state)) {
      dispatch({
        type: API_CALL,
        api: FETCH_PAYMENT_CARDS,
        request: () =>
          getSavedCardsFromStripe(state.auth.account.memberId),
      })
    }
  }
}

export function fetchStripePaymentCards(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: API_CALL,
      api: FETCH_STRIPE_PAYMENT_CARDS,
      request: () => (isStripePaymentElementCardAvailable(state) || isStripe3dsV2Available(state)) ?
        getSavedStripeCards(state.geo.currentCurrency) :
        getSavedCardsOnStripe(state.auth.account.memberId),
    })
  }
}

/**
 * Saves the details given for the current user in the API and updates state
 * with the newest details
 * @param userDetails The user details to save to the API
 * @returns
 */
export function updateUserDetails(userDetails: Partial<App.AuthAccount>, supportPhoneNumber: string | null = null): AppAction {
  return {
    type: API_CALL,
    api: UPDATE_USER_DETAILS,
    request: () => authService.updateUserDetails(userDetails, supportPhoneNumber),
  }
}

/**
 * Manually sync a set of user details into redux
 * Used for when you absolutely have to call the update api method yourself
 * @param userDetails The user details to sync to redux
 */
export function syncUserDetails(userDetails: Partial<App.AuthAccount>): AppAction {
  return {
    type: SYNC_USER_DETAILS,
    userDetails,
  }
}

export function updateAccountPartnership(partnershipPrefix: string, details: App.PartnershipsMap): AppAction {
  return {
    type: API_CALL,
    api: UPDATE_ACCOUNT_PARTNERSHIP,
    request: () => authService.updatePartnershipDetails(details).then(() => details),
    partnershipPrefix,
  }
}

export function hasLegacyOrdersForCurrentUser(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { memberId } = state.auth.account
    if (memberId && !state.auth.ledLegacyOrders.hasFetched) {
      dispatch({
        type: API_CALL,
        api: CHECK_LEGACY_ORDERS_FOR_CURRENT_USER,
        request: () => getLedLegacyOrders(memberId),
      })
    }
  }
}

export function fetchTravellerDetails(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { memberId } = state.auth.account
    if (!memberId) { return }
    dispatch({
      type: API_CALL,
      api: FETCH_CUSTOMER_DETAILS,
      request: () => getCustomerDetails(memberId),
    })
  }
}

export function deleteTravellerDetails(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { memberId } = state.auth.account
    if (!memberId) { return }
    dispatch({
      type: API_CALL,
      api: DELETE_CUSTOMER_DETAILS,
      request: () => deleteCustomerDetails(memberId),
    })
  }
}

export function updateTravellerDetails(travellerDetails: App.CustomerDetails): AppAction {
  return {
    type: API_CALL,
    api: UPDATE_CUSTOMER_DETAILS,
    request: () => updateCustomerDetails({
      ...travellerDetails,
    }),
  }
}

export function saveCustomerSignature(signature: string): AppAction {
  return {
    type: SAVE_CUSTOMER_SIGNATURE,
    signature,
  }
}

export function deleteCustomerSignature(): AppAction {
  return {
    type: DELETE_CUSTOMER_SIGNATURE,
  }
}

export function GSILoadComplete(): AppAction {
  return {
    type: GSI_SCRIPT_LOADED,
  }
}

export function sendOTPVerificationCode(user: App.User): AppAction {
  return {
    type: API_CALL,
    api: SEND_VERIFICATION_CODE,
    request: () => authService.sendOTPVerificationCode(user),
  }
}

export function validateOTPVerificationCode(user: App.User, code: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const luxPlusEnabled = isLuxPlusEnabled(state)
    dispatch({
      type: API_CALL,
      api: USER_LOGIN,
      request: () => authService.validateOTPVerificationCode(user, code, state.geo.currentRegionCode, luxPlusEnabled),
      source: 'otp',
    })
  } }

export function setCustomerValue(price: number): AppAction {
  const value = price >= HIGH_VALUE_OFFER_AMOUNT ? 'highValue' : price >= MID_VALUE_OFFER_AMOUNT ? 'midValue' : undefined
  return {
    type: SET_CUSTOMER_VALUE,
    value,
  }
}

/**
 * Call to clear any existing auth errors
 */
export function clearAuthError(): AppAction {
  return {
    type: CLEAR_AUTH_ERROR,
  }
}

export function fetchCustomerTravellersDetails(): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: FETCH_CUSTOMER_TRAVELLERS,
      request: () => getCustomerTravellers(),
    })
  }
}

export function destroyCustomerTravellerDetails(id: string): AppAction {
  return (dispatch) => {
    if (!id) { return }
    dispatch({
      type: API_CALL,
      api: DELETE_CUSTOMER_TRAVELLER,
      id,
      request: () => deleteCustomerTraveller(id),
    })
  }
}

export function createCustomerTravellerDetails(customerTraveller: Omit<App.CustomerTraveller, 'id'>) {
  return {
    type: API_CALL,
    api: SUBMIT_CUSTOMER_TRAVELLER,
    request: () => createCustomerTraveller(customerTraveller),
  }
}

export function updateCustomerTravellerDetails(customerTraveller: App.CustomerTraveller) {
  return {
    type: API_CALL,
    api: SUBMIT_CUSTOMER_TRAVELLER,
    request: () => updateCustomerTraveller(
      customerTraveller,
    ),
  }
}

export function resetCustomerTravellerSubmission() {
  return {
    type: RESET_CUSTOMER_TRAVELLER_SUBMISSION,
  }
}

export function addToUserCart(items: Array<App.Checkout.AnyItem>, skipNotification: boolean = false): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    dispatch({
      type: ADD_USER_CART_ITEMS,
      items: items.map(prepareItem),
    })

    // If any of the new items are flights, save all other flights for later
    const hasFlightItems = items.some(isFlightItem)
    if (hasFlightItems) {
      const existingFlightItems = getUserCartItemsArray(state)
        .filter(isFlightItem)
        .filter(item => !items.some(newItem => newItem.itemId === item.itemId))

      existingFlightItems.forEach(item => {
        if (!state.auth.userCart.itemStates[item.itemId]?.saveForLater) {
          dispatch(userCartItemsSaveForLater([item.itemId]))
        }
      })
    }

    if (!skipNotification) {
      const { heading, description } = getAddToCartSnackbarData(state, items)
      showAddToUserCartSnackbar(description, heading)
    }
  }
}

export function addUserCartConnectedRooms(offerId: string): Actions['ADD_USER_CART_CONNECTED_ROOMS'] {
  return {
    type: ADD_USER_CART_CONNECTED_ROOMS,
    connectedRoomOfferIds: [offerId],
  }
}

export function addUserCartMultipleConnectedRooms(offerIds: Array<string>): Actions['ADD_USER_CART_CONNECTED_ROOMS'] {
  return {
    type: ADD_USER_CART_CONNECTED_ROOMS,
    connectedRoomOfferIds: offerIds,
  }
}

export function removeUserCartConnectedRoom(offerId: string): Actions['REMOVE_USER_CART_CONNECTED_ROOM'] {
  return {
    type: REMOVE_USER_CART_CONNECTED_ROOM,
    connectedRoomOfferId: offerId,
  }
}

export function clearUserCartPurchased(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch<Actions['CLEAR_PURCHASED_USER_CART_ITEMS']>({
      type: CLEAR_PURCHASED_USER_CART_ITEMS,
      purchasedItemIds: new Set(state.checkout.cart.items.map(item => item.itemId)),
    })
  }
}

export function moveCheckoutItemsToUserCart(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(addToUserCart(getUserCartAbandonableItems(state, state.checkout.cart.items)))
    const connectedRoomOfferIds = state.checkout.cart.connectedRoomOfferIds
    if (connectedRoomOfferIds) {
      dispatch(addUserCartMultipleConnectedRooms(connectedRoomOfferIds))
    }
  }
}

export function syncUserCart(userCartState: App.UserCartState): Actions['SYNC_USER_CART'] {
  return {
    type: SYNC_USER_CART,
    userCartState,
  }
}

export function userCartItemsSaveForLater(itemIds: Array<string>): Actions['SAVE_USER_CART_ITEMS_FOR_LATER'] {
  return {
    type: SAVE_USER_CART_ITEMS_FOR_LATER,
    itemIds,
  }
}

export function saveAllUserCartItemsForLater(): Actions['SAVE_ALL_USER_CART_ITEMS_FOR_LATER'] {
  return {
    type: SAVE_ALL_USER_CART_ITEMS_FOR_LATER,
  }
}

export function userCartItemUpdate(item: App.Checkout.AnyItem): Actions['UPDATE_USER_CART_ITEM'] {
  return {
    type: UPDATE_USER_CART_ITEM,
    item,
  }
}

export function userCartItemsDelete(itemIds: Array<string>): Actions['DELETE_USER_CART_ITEMS'] {
  return {
    type: DELETE_USER_CART_ITEMS,
    itemIds,
  }
}

export function userCartItemsHardDelete(itemIds: Array<string>): Actions['HARD_DELETE_USER_CART_ITEMS'] {
  return {
    type: HARD_DELETE_USER_CART_ITEMS,
    itemIds,
  }
}

export function userCartItemUndo(itemIds: Array<string>): Actions['UNDO_USER_CART_ITEMS_DELETE'] {
  return {
    type: UNDO_USER_CART_ITEMS_DELETE,
    itemIds,
  }
}

export function fetchUserCart({ token }: { token?: string } = {}): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const isLoggedIn = selectLoggedIn(state)
    const hasItems = Object.keys(state.auth.userCart.items).length > 0
    const isFetching = state.auth.userCart.fetching
    if (!isLoggedIn || hasItems || isFetching) { return }

    dispatch({
      type: API_CALL,
      api: FETCH_USER_CART,
      request: () => getUserCart(token),
    })
  }
}

export function deleteAllUserCartItems(): Actions['RESET_USER_CART'] {
  return {
    type: RESET_USER_CART,
  }
}
